import { render, staticRenderFns } from "./BestBuyBannersWrapper.vue?vue&type=template&id=38eb7fcf&scoped=true&"
import script from "./BestBuyBannersWrapper.vue?vue&type=script&lang=js&"
export * from "./BestBuyBannersWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BestBuyBannersWrapper.vue?vue&type=style&index=0&id=38eb7fcf&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb7fcf",
  null
  
)

export default component.exports